import { render, staticRenderFns } from "./SchoolSearch.vue?vue&type=template&id=2a96027e&scoped=true&lang=pug&"
import script from "./SchoolSearch.vue?vue&type=script&lang=js&"
export * from "./SchoolSearch.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSearch.vue?vue&type=style&index=0&id=2a96027e&prod&scoped=true&lang=css&"
import style1 from "./SchoolSearch.vue?vue&type=style&index=1&id=2a96027e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a96027e",
  null
  
)

export default component.exports